import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '@styles/theme';

const CheckboxContainer = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 3px;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  outline: 0;
`;

function backgroundStyle(props) {
  if (props.checked && !props.disabled) {
    return 'rgb(16, 107, 87)';
  }

  if (props.checked && props.disabled) {
    return 'rgb(197, 202, 214)';
  }

  return 'rgb(255, 255, 255)';
}

function boxShadowStyle(props) {
  if (props.checked && !props.disabled) {
    return 'inset 0px 0px 1px 1px rgba(0, 0, 0, 0.15)';
  }

  if (props.checked && props.disabled) {
    return 'inset 0px 0px 1px 1px rgba(0, 0, 0, 0.15)';
  }

  if (!props.checked && props.disabled) {
    return 'inset 0px 0px 0px 1px rgba(0, 0, 0, 0.1)';
  }

  return 'inset 0px 3px 5px 0px rgba(0, 0, 0, 0.1), inset 0px 0px 1px 1px rgba(0, 0, 0, 0.15)';
}

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: ${props => (props.variant === 'radio' ? '10px' : '4px')};
  transition: all 150ms;

  outline: 0;

  background: ${props => backgroundStyle(props)};
  box-shadow: ${props => boxShadowStyle(props)};

  ${Icon} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')};
    opacity: ${props => (props.disabled ? 0.5 : 1)};
    stroke: ${props => (props.checked ? colors.white : colors.darkGray)};
  }
`;

function Checkbox(props) {
  const { checked, disabled, variant, ...restProps } = props;
  return (
    <CheckboxContainer>
      <HiddenCheckbox checked={checked} disabled={disabled} {...restProps} />
      <StyledCheckbox checked={checked} disabled={disabled} variant={variant}>
        {variant !== 'radio' ? (
          <Icon viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </Icon>
        ) : (
          <Icon viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="8" />
          </Icon>
        )}
      </StyledCheckbox>
    </CheckboxContainer>
  );
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  variant: PropTypes.string
};

Checkbox.defaultProps = {
  checked: false,
  variant: 'checkbox'
};

export default Checkbox;
